<div class="min-h-screen overflow-x-hidden" style="background: var(--theme-bg); color: var(--theme-text)">
  <!-- Navigation -->
  <app-navbar></app-navbar>

  <!-- Hero -->
  <app-hero-section></app-hero-section>

  <!-- Platform highlights bar -->
  <app-stats-bar></app-stats-bar>

  <!-- About Aurrica + Africa map -->
  <app-about-section></app-about-section>

  <!-- Platform features — 3×2 bento grid -->
  <app-features-section></app-features-section>

  <!-- Freight Marketplace — how it works -->
  <app-marketplace-section></app-marketplace-section>

  <!-- What We Do — feature cards -->
  <app-services-section></app-services-section>

  <!-- Partners ticker -->
  <app-partners-section></app-partners-section>

  <!-- FAQ -->
  <app-faq-section></app-faq-section>

  <!-- Call to action -->
  <app-cta-section></app-cta-section>

  <!-- Footer -->
  <app-footer-section></app-footer-section>
</div>
